import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ChatService } from '@messages/infra';
import { GetChannelDetailsPathParams } from '@core-http';
import { ChannelDetailsQueryResult } from './channel-details.query-result';

export class ChannelDetailsQueryHandler {
  private readonly chatService: ChatService = inject(ChatService);

  details(channelId: string): Observable<ChannelDetailsQueryResult> {
    const pathParams: GetChannelDetailsPathParams = { channelId };

    return this.chatService.channelDetails(pathParams);
  }
}
